<template>
    <label
        :class="{'uik-checkbox__wrapper--loading': isLoading}"
        class="uik-checkbox__wrapper">
        <input
            :name="name"
            :checked="value"
            :disabled="disabled || isLoading"
            class="uik-checkbox__checkbox"
            type="checkbox"
            @change="$emit('change', !value)"
        />
        <div
            :class="color != '' ? color:''"
            class="uik-checkbox__label">
            <UikLoader
                v-if="isLoading"
                :color="color ? color:'success'"
                :size="0.4"
                type="spinner-fade"
            />
            <svg class="uik-checkbox__checkboxIcon" height="6px" version="1.1" viewbox="0 0 8 6" width="8px">
                <defs>
                </defs>
                <g id="Symbols" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                    <g id="Checkbox/Checked/Default" fill="#FFFFFF" transform="translate(-4.000000, -5.000000)">
                        <g id="Checkbox/Checked">
                            <path id="Check" d="M6.65183265,10.8942434 L4.10636422,8.33133321 C3.96454526,8.1903244 3.96454526,7.96081005 4.10636422,7.81830114 L4.62054884,7.30601913 C4.76236779,7.16501031 4.99291451,7.16501031 5.13473346,7.30601913 L6.9092886,9.10013126 L10.8649465,5.10613163 C11.0067655,4.96512282 11.2373122,4.96512282 11.3791312,5.10613163 L11.8933158,5.6191637 C12.0351347,5.76017251 12.0351347,5.9904369 11.8933158,6.13069567 L7.16601727,10.8942434 C7.02419831,11.0352522 6.7936516,11.0352522 6.65183265,10.8942434">
                            </path>
                        </g>
                    </g>
                </g>
            </svg>
            {{ label }}
        </div>
        <p v-if="description" class="uik-checkbox__description">{{ description }}</p>
    </label>
</template>

<script>
export default {
    name: "UikCheckbox",
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        label: { type: String, default: "" },
        value: { type: Boolean, default: false },
        description: { type: String, default: "" },
        name: { type: String, default: "" },
        checked: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        color: { type: String, default: "" },
        isLoading: { type: Boolean, default: false },
        emitOnCreate: { type: Boolean, default: false }
    },
    mounted () {
        if (this.checked && this.emitOnCreate) {
            this.$emit("change", true)
        } else if (!this.checked && this.emitOnCreate) {
            this.$emit("change", false)
        }
    }
}
</script>

<style lang="scss">
.uik-checkbox__wrapper {
  display: inline-block;
  line-height: 17px;
  user-select: none;
  .uik-checkbox__checkbox {
    width: 0px;
    height: 0px;
    overflow: hidden;
    position: absolute;
    visibility: hidden;
  }
  .uik-checkbox__description {
    margin-top: 2px;
    margin-left: 26px;
    color: $textSecondary;
  }
  .uik-checkbox__label {
    color: $textBase;
    font-size: 0.875rem;
    line-height: 19px;
    color: $textBase;
    display: inline-flex;
    position: relative;
    cursor: pointer;
    &:hover {
      color: $textMain;
    }
  }
  .uik-checkbox__checkbox[disabled]+.uik-checkbox__label {
    cursor: not-allowed;
  }
  .uik-checkbox__checkbox:checked+.uik-checkbox__label {
    color: $textMain;
    &:hover {
      color: $textBase;
    }
  }
}

.uik-checkbox__wrapper:not(.uik-checkbox__toggle):not(.uik-checkbox__radio) {
  .uik-checkbox__label {
    &:before {
      text-align: center;
      line-height: 14px;
      padding-left: 1px;
      color: #fff;
      width: 16px;
      min-width: 16px;
      height: 16px;
      content: "";
      font-size: 7px;
      background-color: #FFF;
      border: 1px solid #DFE3E9;
      border-radius: 3px;
      margin-right: 10px;
      display: inline-block;
      transition: border .2s, background .2s;
      vertical-align: middle;
      transform: translateY(1px)
    }
    .uik-checkbox__checkboxIcon {
      position: absolute;
      left: 4px;
      top: 6px;
      display: none;
    }
  }
  input[disabled]+.uik-checkbox__label:before {
    /* Checkbox: */
    background-image: linear-gradient(0deg, #F6F7F9 0%, #FFFFFF 100%);
    border: 1px solid $borderColorDarker;
    box-shadow: 0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05);
    border-radius: 3px;
    /* Rectangle: */
    background: rgba(#BCBCBC, .25);
  }
  .uik-checkbox__checkbox:checked+.uik-checkbox__label {
    &:before {
      background-color: $success;
      border-color: $success;
    }
    @each $name,
    $color in $colors {
      &:global(.#{$name}) {
        &:before {
          color: white;
          background-color: $color;
          border-color: $color;
        }
      }
    } // extra
    .uik-checkbox__checkboxIcon {
      display: block;
    }
  }
}
.uik-checkbox__wrapper--loading {
  .uik-checkbox__label {
    &:before {
      opacity: 0;
    }
  }
  .uik-checkbox__checkboxIcon {
    opacity: 0;
  }
  .uik-loader {
    position: absolute;
    top: -11px;
    left: -12px;
  }
}
</style>
